import React, { useEffect, useRef, useState } from "react"
import Image1 from '../assets/imagemob1.png';
import Image2 from '../assets/imagemob2.png';
import Image3 from '../assets/imagemob3.png';
import Image4 from '../assets/imagemob4.png';
import Image5 from '../assets/imagemob5.png';
import Image6 from '../assets/imagemob6.png';
import "../style.css"

export default function HowtoplayMob() {
    const videoRef = useRef(null);
    const [count, setCount] = useState(0);
    const [autoCycle, setAutoCycle] = useState(true);
    const totalSteps = 6;
    const cycleTimeout = useRef();

    // Auto-cycle effect
    useEffect(() => {
        if (!autoCycle) return;
        function nextStep() {
            setCount((prev) => (prev + 1) % totalSteps);
        }
        cycleTimeout.current = setTimeout(nextStep, 20000);
        return () => clearTimeout(cycleTimeout.current);
    }, [count, autoCycle]);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.pause();
            video.removeAttribute("src");
            video.load();
            video.onloadeddata = () => {
                video.play().catch((err) => {
                    console.error("Error playing video:", err);
                });
            };
        }
    }, [count]);

    // Click handler for steps
    const handleStepClick = (idx) => {
        setCount(idx);
        setAutoCycle(false);
        setTimeout(() => setAutoCycle(true), 20000);
    };

    const choosUs1 = [
        { classN: "mobile", width: "42.6px", img: "/Icons/opener-issues1.webp", text: "01 -  Signup & Login", desc: "Register to create your profile & log in details." },
        { classN: "mobile1", width: "44px", img: "/Icons/opener-issues2.webp", text: "02 - Choose to play the Round with 1 or 2 Picks", desc: "Decide if you are joining a New Round with 1 or 2 picks. Each player can play a maximum of 2 picks per Round." },
        { classN: "mobile2", width: "52.74px", img: "/Icons/opener-issues3.webp", text: "03 - Buy or Redeem Tokens", desc: "Tokens are needed to play in each Round. A minimum of 1 token is required per Pick." },
        { classN: "mobile3", width: "42.6px", img: "/Icons/opener-issues1.webp", text: "04 - Pick your Team", desc: "Assign your picks to teams from the upcoming match week. You progress if your team wins, if not you are eliminated." },
        { classN: "mobile4", width: "44px", img: "/Icons/opener-issues2.webp", text: "05 - Stay Alive", desc: "While progressing in any Round, you cannot pick the same teams from previous weeks." },
        { classN: "mobile5", width: "52.74px", img: "/Icons/opener-issues3.webp", text: "06 - Win the Prize", desc: "When there are 5 or fewer players, you will get a chance to vote on splitting the jackpot, otherwise keep playing on to be the last man standing." },
    ]

    const stepImages = [
        Image1,
        Image2,
        Image3,
        Image4,
        Image5,
        Image6
    ];

  return (
    <div className="flex laptop-l-min:flex-row laptop-min:flex-row tablet:flex-row flex-col laptop-l-min:gap-32 laptop-min:gap-20 items-stretch laptop-l-min:mt-[3.8rem] laptop-min:mt-[3.8rem] mt-[1.25rem]">
        <div className="flex-none w-full flex flex-col justify-between relative">
            {choosUs1?.map((c, index) => (
                <div
                    key={index}
                    className={`px-[34px] py-6 rounded-[5px] relative cursor-pointer ${count === index ? 'bg-[#F6FAFF]' : 'bg-white'}`}
                    style={{ display: count === index ? 'block' : 'none' }}
                    onClick={() => handleStepClick(index)}
                >
                    <div className="text-[16px] text-[#000000] font-[600] laptop-l-min:leading-[38px] laptop-min:leading-[24px] pb-4 font-archivo">{c.text}</div>
                    <div className="text-[14px] text-[#000000] font-[500] laptop-l-min:leading-[37px] laptop-min:leading-[23px] pb-4 font-inter opacity-[66%]">{c.desc}</div>
                    <div className={`absolute inset-x-0 bottom-0 left-0 h-[4px] bg-[#007FFF] transition-all duration-200 ease-linear ${count === index ? 'w-full' : 'w-0'}`}></div>
                </div>
            ))}
            {count > 0 && (
                <button 
                    onClick={() => setCount(count > 0 ? count - 1 : 0)} 
                    className="absolute left-0 top-[40%] transform -translate-x-1/2 z-10"
                >
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="#007FFF"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M8.21778 12.4678C8.07718 12.6084 7.99819 12.7992 7.99819 12.998C7.99819 13.1969 8.07718 13.3876 8.21778 13.5283L12.4605 17.771C12.5297 17.8427 12.6125 17.8998 12.704 17.9391C12.7955 17.9784 12.8939 17.9991 12.9935 18C13.0931 18.0008 13.1918 17.9819 13.284 17.9441C13.3762 17.9064 13.4599 17.8507 13.5303 17.7803C13.6007 17.7099 13.6564 17.6262 13.6942 17.534C13.7319 17.4418 13.7508 17.3431 13.75 17.2435C13.7491 17.1439 13.7284 17.0455 13.6891 16.954C13.6498 16.8625 13.5927 16.7797 13.521 16.7105L9.80853 12.998L13.521 9.28553C13.6577 9.14408 13.7332 8.95463 13.7315 8.75798C13.7298 8.56134 13.651 8.37323 13.5119 8.23417C13.3728 8.09511 13.1847 8.01624 12.9881 8.01453C12.7914 8.01282 12.602 8.08842 12.4605 8.22503L8.21778 12.4678Z" fill="white" />
                    </svg>
                </button>
            )}
            
            {count < choosUs1?.length - 1 && (
                <button 
                    onClick={() => setCount(count < choosUs1?.length - 1 ? count + 1 : count)} 
                    className="absolute right-0 top-[40%] transform translate-x-1/2 z-10"
                >
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="#007FFF"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M15.5322 12.4678C15.6728 12.6084 15.7518 12.7992 15.7518 12.998C15.7518 13.1969 15.6728 13.3876 15.5322 13.5283L11.2895 17.771C11.2203 17.8427 11.1375 17.8998 11.046 17.9391C10.9545 17.9784 10.8561 17.9991 10.7565 18C10.6569 18.0008 10.5582 17.9819 10.466 17.9441C10.3738 17.9064 10.2901 17.8507 10.2197 17.7803C10.1493 17.7099 10.0936 17.6262 10.0558 17.534C10.0181 17.4418 9.99916 17.3431 10 17.2435C10.0009 17.1439 10.0216 17.0455 10.0609 16.954C10.1002 16.8625 10.1573 16.7797 10.229 16.7105L13.9415 12.998L10.229 9.28553C10.0923 9.14408 10.0168 8.95463 10.0185 8.75798C10.0202 8.56134 10.099 8.37323 10.2381 8.23417C10.3772 8.09511 10.5653 8.01624 10.7619 8.01453C10.9586 8.01282 11.148 8.08842 11.2895 8.22503L15.5322 12.4678Z" fill="white" />
                    </svg>
                </button>
            )}
        </div>
        <div className="flex-1 relative flex items-start mt-10 justify-center">
            <img src={stepImages[count]} alt={`Step ${count + 1}`} className="h-[450px]" />
        </div>
    </div>
  )
}
